import React from 'react';
import { AppButton, Box, Inscription, NewTabIcon } from '@common-fe/common-fe';
import styled from 'styled-components';

import useContinueInAdminPortal from './useContinueInAdminPortal';

const ResponsiveWrapper = styled(Box)`
  flex-direction: row;
  justify-content: space-between;

  @media (max-width: 1500px) {
    flex-direction: column;
  }
`;

const ContinueInAdminPortal = () => {
  const { isVisible, handleGoToAdminPortal } =
    useContinueInAdminPortal();

  if (!isVisible) {
    return null;
  }

  return (
    <ResponsiveWrapper
      data-testid="continue-in-admin-portal"
      background="infoContainer"
      border={{ color: 'infoBorder', size: 'small' }}
      round="container2Round"
      pad={{ horizontal: 'spacing24', vertical: 'spacing16' }}
      margin={{ top: 'spacing12' }}
    >
      <Box direction="column" width={{ max: 'fit-content' }} margin={{ right: 'spacing8' }}>
        <Inscription
          weight="bold"
          color="textBody"
          size="14px"
          lineHeight="20px"
          data-testid="continue-in-admin-portal-title"
        >
          Continue in Admin Portal
        </Inscription>
        <Inscription
          color="textBody"
          size="14px"
          lineHeight="20px"
          data-testid="continue-in-admin-portal-description"
        >
          This form type cannot be fully processed here. Please continue to the Admin Portal to review
          the details and complete the required actions.
        </Inscription>
      </Box>
      <Box justify="center" width={{ min: 'fit-content' }}>
        <AppButton
          testId="go-to-admin-portal"
          buttonType="secondary"
          onClick={handleGoToAdminPortal}
          rightIcon={<NewTabIcon />}
        >
          Go to Admin Portal
        </AppButton>
      </Box>
    </ResponsiveWrapper>
  );
};

export default ContinueInAdminPortal;
